import { Fragment } from 'react';

/**
 * Render a `ts_headline` snippet WITHOUT trusting it as markup.
 *
 * The backend wraps matches in [[hl]] sentinels rather than in <b>, because
 * ts_headline does not escape the source text: a document containing a script
 * tag would otherwise arrive as live markup from a corpus this application does
 * not control. Splitting on the sentinels and emitting React elements means the
 * surrounding text is escaped by React itself and never interpreted, so the
 * highlight survives and the injection cannot.
 *
 * One definition, shared by every search screen. The sentinel strings are half a
 * contract with the SQL that produces them, and two copies of a contract drift.
 */
export function Snippet({ text }: { text: string }) {
  const parts = text.split(/\[\[hl\]\]|\[\[\/hl\]\]/);
  return (
    <>
      {parts.map((part, index) => (
        <Fragment key={index}>
          {index % 2 === 1 ? <mark className="bg-amber-500/30 text-foreground">{part}</mark> : part}
        </Fragment>
      ))}
    </>
  );
}
